import React, { useEffect, useState } from "react";
import NightingaleChart from "../../CHARTS/NightingalePieChart";
import { sumArrayOfObjects } from "../../Utilitie";

/** Label mapping */
const bucketMap = {
  LESS_THEN_EQUAL_TO_THIRTY_MIN: "≤ 30 Minutes",
  MORE_THEN_THIRTY_MIN_LESS_THAN_ONE_HOUR: ">30 — ≤1 Hour",
  MORE_THEN_ONE_HOUR_LESS_THEN_TWO_HOUR: ">1 — ≤2 Hours",
  MORE_THEN_TWO_HOUR_LESS_THEN_THREE_HOUR: ">2 — ≤3 Hours",
  MORE_THEN_THREE_HOURS: ">3 Hours",
};

/** FIXED color per bucket name */
const bucketColorMap = {
  "≤ 30 Minutes": "#1d51efa6",
  ">30 — ≤1 Hour": "#f28f2ba8",
  ">1 — ≤2 Hours": "#e635389c",
  ">2 — ≤3 Hours": "#47e63294",
  ">3 Hours": "#3de9dbad",
};

const PDDNightingaleChart = ({ data, year }) => {
  const [chartInfo, setChartInfo] = useState(null);

  useEffect(() => {
    if (!data) return;

    let tempChart = [];

    const sum = sumArrayOfObjects(
      data.filter((o) => o.PDD_YEAR === year),
      [],
      ["PDD_YEAR"]
    );

    const sumObj = sum?.[0];

    if (!sumObj) return;

    Object.entries(sumObj).forEach(([key, value]) => {
      if (key !== "ID" && key !== "group_id" && key !== "TOTAL_CASES") {
        const name = bucketMap[key];

        tempChart.push({
          name,
          value,
          itemStyle: {
            color: bucketColorMap[name], // 🔒 FIXED COLOR
          },
        });
      }
    });

    // sorting will NOT affect colors anymore
    // tempChart.sort((a, b) => b.value - a.value);

    setChartInfo(tempChart);
  }, [data, year]);

  return (
    <div>
      {chartInfo && (
        <NightingaleChart
          data={chartInfo}
          title={`PDD Lobby Distribution (${year})`}
          height={400}
        />
      )}
    </div>
  );
};

export default PDDNightingaleChart;
